var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout-sider',{attrs:{"collapsible":true,"trigger":null,"collapsed":_vm.collapsed,"width":"250"},on:{"collapse":_vm.onCollapse}},[_c('div',{staticClass:"logo"}),_c('sidebar-menu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }